var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.120192,10.3810704 L16,15.9073122 L7.87980795,10.3810704 C8.03216254,10.0429428 8.38636714,9.8 8.8,9.8 L23.2,9.8 C23.6136329,9.8 23.9678375,10.0429428 24.120192,10.3810704 Z M24.2,12.2621323 L24.2,21.25 C24.2,21.76555 23.7531372,22.2 23.2,22.2 L8.8,22.2 C8.24686281,22.2 7.8,21.76555 7.8,21.25 L7.8,12.2621323 L16,17.8426878 L24.2,12.2621323 Z M16,0 C24.837,0 32,7.163 32,16 C32,24.837 24.837,32 16,32 C7.163,32 -2.84217094e-14,24.837 -2.84217094e-14,16 C-2.84217094e-14,7.163 7.163,0 16,0 Z M8.8,8.2 C7.37313719,8.2 6.2,9.34055005 6.2,10.75 L6.2,21.25 C6.2,22.65945 7.37313719,23.8 8.8,23.8 L23.2,23.8 C24.6268628,23.8 25.8,22.65945 25.8,21.25 L25.8,10.75 C25.8,9.34055005 24.6268628,8.2 23.2,8.2 L8.8,8.2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.0780909b4f7b6104c0c5cfb00e123417.svg";
export { ForwardRef as ReactComponent };